
<div class="container">
  <div class="containerLogin login-container">
    <form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">
      <div class="row mt-5">
        <div class="col-md-3"></div>
        <div class="col-md-6 login-form-1">
          <h3 class="misc-titles text-center">Login</h3>
          <div class="container" style="border:1px solid #bebaba">
            <p class="misc-titles text-center">
              <br/><br/>
              Your Unique ID and PIN are located on the claim form that was mailed to you.
              If you need assistance locating that information, you may email
              <a href="mailto:info@CanogaParkClassAction.com">info@CanogaParkClassAction.com</a>
              or call <b>833-419-5050</b> to leave a message and receive a call back.
              <br /><br/>
            </p>
            <div class="form-group">
              <label for="uniqueId" style="font-weight:bold">Unique Id: <span style="color:red" class="required"> *</span></label>
              <input type="text" class="form-control" formControlName="uniqueId" trim="blur" autocomplete="off"
                     [ngClass]="{ 'is-invalid': submitted && f.uniqueId.errors }" />
              <div *ngIf="submitted && f.uniqueId.errors" class="invalid-feedback">
                <div *ngIf="f.uniqueId.errors.required">This field is required</div>
                <div *ngIf="f.uniqueId.errors.minlength">This field must be at least 8 characters</div>
                <div *ngIf="f.uniqueId.errors.maxlength">
                  This field must not be greater than 8 characters
                </div>
                <div *ngIf="f.uniqueId.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
              </div>
            </div>
            <div class="form-group">
              <label for="pin" style="font-weight:bold">Pin: <span style="color:red" class="required"> *</span></label>
              <input type="text" class="form-control" formControlName="pin" trim="blur" autocomplete="off"
                     [ngClass]="{ 'is-invalid': submitted && f.pin.errors }" />
              <div *ngIf="submitted && f.pin.errors" class="invalid-feedback">
                <div *ngIf="f.pin.errors.required">This field is required</div>
                <div *ngIf="f.pin.errors.minlength">This field must be at least 6 characters</div>
                <div *ngIf="f.pin.errors.maxlength">
                  This field must not be greater than 6 characters
                </div>
                <div *ngIf="f.pin.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12 text-center">
                <div class="form-group">
                  <button class="btn btn-primary" id="login" [disabled]="clicked">Login</button>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
          <br />
        </div>

        <div class="col-md-3"></div>
      </div>

    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
    <div class="row mt-3" *ngIf="showDivHasFiled == true">
      <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:2.0em">
        This UniqueId and Pin has already been used. Please contact the Settlement Administrator at <a href="mailto:info@CanogaParkClassAction.com">info@CanogaParkClassAction.com</a> for questions.
      </div>
    </div>
  </div>
</div>
